import { ItalicIcon } from "components/common/Icons/ItalicIcon";
import { useFindTextBox } from "../useFindTextBox";
import { useItalic } from "./useItalic";

export interface ItalicProps {
    textBoxId: string;
}

export const Italic = ({ textBoxId }: ItalicProps) => {
    const { textBox } = useFindTextBox(textBoxId);
    const { isActive, handleClick } = useItalic(textBox);
    return (
        <button
            className={`w-10 h-10 flex items-center justify-center ${
                !isActive && "hover:bg-irGray-100 dark:hover:bg-darkSurface-300"
            } ${isActive ? "bg-irGray-200" : "bg-transparent"} rounded-lg`}
            onClick={handleClick}
        >
            <ItalicIcon />
        </button>
    );
};
